import { invalidateExploreSummary } from '../../../explore/exploreRefresh';
import api from '../../../../api/api';
import queryClient from '../../../../queryClient';
import { applyTimelineRegionCorrection } from '../../../explore/timelineCache';
export async function correctAlbumRegion(albumId, displayRegion, client = queryClient) {
  if (!Number.isSafeInteger(albumId) || albumId <= 0 || !['KR', 'GLOBAL'].includes(displayRegion))
    throw new Error('Invalid region correction');
  const result = await api.putAuth(`/albums/${albumId}/region-correction`, { displayRegion });
  await applyTimelineRegionCorrection(client, albumId, displayRegion);
  await invalidateExploreSummary(client, 'region');
  return result;
}
